import { render, staticRenderFns } from "./qrdownload.vue?vue&type=template&id=2e4910ba&scoped=true"
import script from "./qrdownload.vue?vue&type=script&lang=js"
export * from "./qrdownload.vue?vue&type=script&lang=js"
import style0 from "./qrdownload.vue?vue&type=style&index=0&id=2e4910ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4910ba",
  null
  
)

export default component.exports